import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';

import {
  getDiningOptionsRequest, getDiningOptionsSuccess,
  getDiningOptionsFailure, setCruiseItineraryDiningOptions,
} from '../../slices/trip';
import convertObjToQueryStr from '../../../helpers/convertObjToQueryStr';
import formatStateroomsForRequest from '../../../helpers/formatters/formatStateroomsForRequest';

const queryString = require('query-string');

function* getDiningOptionsWorker({
  payload: {
    tripId,
    cruiseItinerary,
    tripCruiseBookingResponse,
    isManagingDining,
  },
}) {
  const { staterooms } = yield select((store) => store.tripSearch.searchObj);
  const { itineraryId, cruiseLine } = cruiseItinerary.itineraryDetail;

  try {
    const requestStaterooms = _.map(staterooms, (s, roomIndex) => ({
      searchInput: formatStateroomsForRequest(s, cruiseLine.cruiseLineId),
      roomIndex,
      cabinCategoryCode: cruiseItinerary.cabins[roomIndex]
        .selectedShipCabinCategory.cabinCategoryCode,
      cabinCategoryRateOptionCode: cruiseItinerary.cabins[roomIndex]
        .selectedRateOption.rateOptionCode,
      bookingReference: tripCruiseBookingResponse && tripCruiseBookingResponse.length
        ? (_.find(tripCruiseBookingResponse,
          (b) => b.roomIndex === roomIndex) || {}).bookingReference : undefined,
    }));

    const request = {
      itineraryId,
      ...convertObjToQueryStr(requestStaterooms, 'staterooms'),
    };

    const qs = queryString.stringify(request, { skipNull: true });

    const url = `/cruises/getDiningOptions?${qs}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(getDiningOptionsSuccess({
        tripId,
        diningOptions: data,
      }));

      if (!isManagingDining && data && data.length) {
        try {
          yield put(setCruiseItineraryDiningOptions({
            tripId,
            diningOptionsForRooms: _.map(data, (diningOption) => ({
              roomIndex: diningOption.roomIndex,
              selectedDiningSeat: (diningOption.diningSeats || [])[0],
              selectedDiningTable: (diningOption.diningTables || [])[0],
            })),
          }));
        } catch (ex) {
          console.log(ex);
        }
      }
    } else {
      yield put(getDiningOptionsFailure('Dining options not found!'));
    }
  } catch (error) {
    yield put(getDiningOptionsFailure(`${error.response.data.title} ${error.response.data.detail}`));
  }
}

function* getDiningOptionsWatcher() {
  yield takeLatest(getDiningOptionsRequest.toString(), getDiningOptionsWorker);
}

export default getDiningOptionsWatcher;
